module.exports = ".icon {\n    padding: 0 14px;\n}\n\n.spacer {\n    flex: 1 1 auto;\n}"